import React from "react"
import { useHistory, useLocation, useRouteMatch } from "react-router-dom"
import AccessRoles from "app/components/AccessRoles"
import { RouteObject } from "app/routes"
import ChevronLeft from "components/Icons/ChevronLeft.icon"
import { BreadCrumbWrapper, StyledBackButton } from "./style"

type OwnProps = {
  routes: RouteObject[]
}

type Props = OwnProps

export default function BreadCrumb({ routes }: Props) {
  const history = useHistory()
  const location = useLocation()
  const match = useRouteMatch()
  const route = routes.find(r => r.path === match.path)

  const path = location.pathname.split("/").filter(Boolean)

  if (!route?.breadcrumb) return null

  const { allowedRoles, component } = route.breadcrumb
  const handleClick = () => {
    history.push(`/${path[0]}`)
  }

  return (
    <AccessRoles allowedRoles={allowedRoles}>
      <BreadCrumbWrapper>
        <StyledBackButton onClick={handleClick} variant="text" startIcon={<ChevronLeft />}>
          {component}
        </StyledBackButton>
      </BreadCrumbWrapper>
    </AccessRoles>
  )
}
